const { createSlice } = require("@reduxjs/toolkit");

const initialState = {
  users: {},
  recruiters: {},
  hiringManagers: [],
  companyAdmins: [],
  companies: [],
  selectedCompany: {}
};

const companyUsersSlice = createSlice({
  name: "company-users",
  initialState,
  reducers: {
    setRecruiters: (state, { payload: { recruiters } }) => {
      state.recruiters = recruiters;
    },
    setHiringManagers: (state, { payload: { hiringManagers } }) => {
      state.hiringManagers = hiringManagers;
    },
    setCompanyAdmins: (state, { payload: { companyAdmins } }) => {
      state.companyAdmins = companyAdmins;
    },
    setCompanies: (state, { payload: { companies } }) => {
      state.companies = companies;
    },
    setSelectedCompany: (state, { payload: { selectedCompany } }) => {
      state.selectedCompany = selectedCompany;
    },
  },
});

export const { setRecruiters, setHiringManagers, setCompanyAdmins, setCompanies, setSelectedCompany } = companyUsersSlice?.actions;
export default companyUsersSlice.reducer;
